import { RemoteGetActiveSession } from 'data/usecases/authentication/session';
import { GetActiveSession } from 'domain/usecases';
import { makeApiUrlGetActiveSession } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetActiveSession = (): GetActiveSession => {
  return new RemoteGetActiveSession(
    makeApiUrlGetActiveSession(),
    makeAxiosHttpClient(),
  );
};
